import styled from 'styled-components/macro'

export const InputWrapper = styled.div`
  display: flex;
  max-width: 110px;
`
